import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormHelperText } from 'material-ui/Form';
import TextField from 'material-ui/TextField';

const TextFieldArea = ({
  input,
  label,
  helperText,
  meta: { touched, error },
  ...custom
}) => (
  <FormControl fullWidth error={Boolean(touched && error)}>
    {helperText ? (
      <div>
        <FormHelperText>{helperText}</FormHelperText>
        {label ? <br /> : null}
      </div>
    ) : null}
    <TextField
      label={label}
      underlineShow='false'
      error={Boolean(touched && error)}
      {...input}
      {...custom}
    />
    {touched && error ? <FormHelperText>{error}</FormHelperText> : null}
  </FormControl>
);

TextFieldArea.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.node,
  helperText: PropTypes.string,
  meta: PropTypes.object.isRequired,
};

TextFieldArea.defaultProps = {
  helperText: null,
  label: null,
};

export default TextFieldArea;



// WEBPACK FOOTER //
// ./src/components/FormFields/TextField.js